import request from '@/axios'


export function getUploadedFileInfo (payload, platform_customer_id) {
  return request({
    url:`/file/upload/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getUploadedFilesId (payload) {
  return request({
    url:'/file/upload/add',
    method:'POST',
    data:payload,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}


export function editAssignment (payload, platform_customer_id, assignment_id) {
  return request({
    url: assignment_id ? `/assignment-builder/create/${platform_customer_id}/${assignment_id}` : `/assignment-builder/create/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}


export function deleteAssignment (platform_customer_id, payload) {
  return request({
    url:`/assignment-builder/delete/${platform_customer_id}`,
    method:'POST',
    data: payload
  })
}

export function createAssignment (payload, platform_customer_id) {
  return request({
    url:`/assignment-builder/create/${platform_customer_id}`,
    method:'POST',
    data:payload
  })
}

export function listAssignment (payload, platform_customer_id, page, sorting_obj = {}, table_name = null, filterId = null) {
  let url = `/assignment-builder/list/${platform_customer_id}?page=${page}&table_name=${table_name}&page=${page}${filterId ? `&filter_id=${filterId.filter_id}` : ''}`
  if (Object.entries(sorting_obj).length > 0) {
    url = `assignment-builder/list/${platform_customer_id}?attribute=${sorting_obj ? sorting_obj.attribute : ''}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}${filterId ? `&filter_id=${filterId.filter_id}` : ''}` 
  }
  return request({
    url,
    method:'POST',
    data:payload
  })
}
  

export function listAssignmentCoursework (payload, platform_customer_id, page, sorting_obj, table_name, filter_id) {
  return request({
    url:`/V1/assignment_builder/courseWork/${platform_customer_id}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&filter_id=${filter_id}`,
    method:'POST',
    data:payload
  })
}

export function questionInputType () {
  return request({
    url:'/question-input-types',
    method:'GET'

  })
}


export function deleteAssignmentQuestion (platform_customer_id, assignment_id, question_id) {
  return request({
    url:`assignment-builder/question-delete/${platform_customer_id}/${assignment_id}/${question_id}`,
    method:'DELETE'
  })
}

export function changeStatusById (platform_customer_id, payload) {
  return request({
    url:`assignment-builder/change-status/${platform_customer_id}`,
    
    method:'POST',
    data:payload

  })
}

export function assignmentType () {
  return request({
    url:'/assignment-types',
    method:'GET'

  })
}

export function fetchUser (platform_customer_id) {
  return request({
    url:`/get-all-user/${platform_customer_id}`,
    method:'GET'
  })
}


export function assignmentShare (platform_customer_id, payload) {
  //http://localhost:8000/api/assignment-builder/share/2
  return request({
    url:`/assignment-builder/share/${platform_customer_id}`,
    method:'POST',
    data:payload


  })

}
export function createCourseWork (payload, platform_customer_id) {
  return request({
    url:`/V1/assignment_builder/assign/${platform_customer_id}`,
    method:'POST',
    data:payload


  })

}

// {
//   "ids": [103,104,105],
//   "status":false
//   }


// http://localhost:8000/api/assignment-builder/change-status/2


// export function DeleteAssignment (platform_customer_id, assignment_id) {
//   return request({
//     url:`/assignment-builder/delete/${platform_customer_id}/${assignment_id}`,
//     method:'GET'
//   })
// }

